import withAdvDicTable from './withAdvDicTable';
export default withAdvDicTable;
